export default "__VITE_ASSET__CxGdr$Mq__"